import React, { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import STLViewer_MOD from '../../../utils/STLViewer_MOD';
import AWS from 'aws-sdk';
import config from '../../../../config.json';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

const HistoryListItem = ({ simulation }) => {
    const [stlFileNames, setStlFileNames] = useState([]);
    const [jsonData, setJsonData] = useState({});
    const [stlView, setStlView] = useState(null);
    const [jsonFileName, setJsonFileName] = useState('');

    useEffect(() => {
        const s3 = new AWS.S3();
        const params = {
            //Bucket: 'grn-bucket-web-19b61b70-c6ae-4dff-98f4-8f378b31c9ec',
            Bucket: 'testbucket-516579854',
            Key: `history/${simulation.folder}/${simulation.jsonFileName}`
        };

        s3.getObject(params, (err, data) => {
            if (err) {
                console.error(err);
                return;
            }

            const jsonData = JSON.parse(data.Body.toString());
            setJsonData(jsonData);
            setStlFileNames(simulation.stlFileNames);
            const stlObjects = simulation.stlFileNames.map((fileName) => {
                return {
                   
                    path: `https://testbucket-516579854.s3.amazonaws.com/history/${simulation.folder}/${fileName}`,
                    materialColor: '#0000ff',
                };
            });
            setStlView(<STLViewer_MOD backgroundColor="#000000" objects={stlObjects} />);
        }); 
    }, [simulation]);

    const downloadAllStlFiles = async () => {
        const s3 = new AWS.S3();
        const zip = new JSZip();

        const downloadPromises = simulation.stlFileNames.map(async (stlFileName) => {
            const params = {
                Bucket: 'testbucket-516579854',
                Key: `history/${simulation.folder}/${stlFileName}`,
            };

            const response = await s3.getObject(params).promise();
            const fileData = response.Body;
            zip.file(stlFileName, fileData);
        });

        await Promise.all(downloadPromises);

        const content = await zip.generateAsync({ type: "blob" });
        saveAs(content, `${simulation.folder}_stl_files.zip`);
    };

    const downloadJsonFile = async () => {
        const s3 = new AWS.S3();
        const params = {
            Bucket: 'testbucket-516579854',
            Key: `history/${simulation.folder}/${simulation.jsonFileName}`,
        };

        try {
            const response = await s3.getObject(params).promise();
            const fileData = new Blob([response.Body], { type: "application/json" });
            const fileUrl = URL.createObjectURL(fileData);

            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = simulation.jsonFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            
            URL.revokeObjectURL(fileUrl);
        } catch (err) {
            console.error('Error downloading JSON file:', err);
        }
    };

    const downloadResults = async () => {
        const s3 = new AWS.S3();
        const resultsFolderPrefix = `history/${simulation.folder}/results/`;

        const listParams = {
            Bucket: 'testbucket-516579854',
            Prefix: resultsFolderPrefix,
        };

        try {
            const data = await s3.listObjectsV2(listParams).promise();
            const resultsFiles = data.Contents.filter((obj) => obj.Key !== resultsFolderPrefix);

            if (resultsFiles.length === 0) {
                console.log('No results files found.');
                return;
            }

            const zip = new JSZip();

            await Promise.all(
                resultsFiles.map(async (file) => {
                    const getObjectParams = {
                        Bucket: 'testbucket-516579854',
                        Key: file.Key,
                    };

                    const response = await s3.getObject(getObjectParams).promise();
                    const fileName = file.Key.replace(resultsFolderPrefix, '');

                    zip.file(fileName, response.Body);
                })
            );

            const zipFile = await zip.generateAsync({ type: 'blob' });
            const zipUrl = URL.createObjectURL(zipFile);

            const link = document.createElement('a');
            link.href = zipUrl;
            link.download = `${simulation.folder}-results.zip`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            
            URL.revokeObjectURL(zipUrl);
        } catch (err) {
            console.error('Error downloading results files:', err);
        }
    };


    return (

        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
        

            <Paper
                elevation={3}
                direction={'row'}
                sx={{ p: 2, mb: 1 }}>

                <Grid
                    //height='100vh'
                    sx={{ display: 'flex', flexDirection: 'column' }}>

                    <Grid>
                        <Typography
                            sx={{ mt: 0, mb: 1 }}
                            variant="h5"
                            color="primary"
                            component="div">
                            {simulation.jsonFileName.slice(-24, -5)}
                        </Typography>
                    </Grid>


                    <Grid container alignItems="center" justifyContent="center" sx={{ flexGrow: 1 }}>
                        <Box sx={{ m: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '30vh' }}>
                            {stlView}
                        </Box>
                    </Grid>



                    <TableContainer component={Paper}>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell align="center">Material Types: {jsonData?.object?.["Material-Types"]?.join(", ")}</TableCell>
                                    <TableCell align="center">Voxel Resolution: {jsonData?.object?.["Voxel-Resolution"]?.join(", ")}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="center">
                                        Displacement (X,Y,Z): {jsonData?.object?.["Object-Displacement-x"]?.[0]}, {jsonData?.object?.["Object-Displacement-y"]?.[0]}, {jsonData?.object?.["Object-Displacement-z"]?.[0]} (mm)
                                    </TableCell>
                                    <TableCell align="center">
                                        Orientation: {jsonData?.object?.["Object-Orientation-x"]?.[0]}, {jsonData?.object?.["Object-Orientation-y"]?.[0]} (rad)
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="center">Source Name: {jsonData?.source?.["Source-Name"]?.[0]}</TableCell>
                                    <TableCell align="center">Source Distance: {jsonData?.source?.["Source-Distance"]?.[0]} (mm)</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="center">
                                        Source Energy: {jsonData?.source?.["Source-EnergyMax"]?.[0]} - {jsonData?.source?.["Source-EnergyMax"]?.[jsonData?.source?.["Source-EnergyMax"].length - 1]}
                                    </TableCell>
                                    <TableCell align="center">
                                        Rotation Bounds: {jsonData?.simulation?.["Simulation-Rotation-Bounds"]?.join(", ")}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="center">Rotation Steps: {jsonData?.simulation?.["Simulation-Rotation-Counts"]}</TableCell>
                                    <TableCell align="center">Photon Counts: {jsonData?.simulation?.["Simulation-PhotonCounts"]}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="center">Detector Size: {jsonData?.detector?.["Detector-Size"]?.[0]}</TableCell>
                                    <TableCell align="center">Detector Resolution: {jsonData?.detector?.["Detector-Resolution"]?.[0]}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>





                    <Grid container direction="row" justifyContent="center" alignItems="center" spacing={1} sx={{ mt: 2 }}>
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={downloadAllStlFiles}
                            >
                                Download STL(s)
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={downloadJsonFile}
                            >
                                Download Config
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={downloadResults}
                            >
                                Download Results
                            </Button>
                        </Grid>
                    </Grid>

                </Grid>
            </Paper>
        
        </Grid >
    );
};

export default HistoryListItem;
